import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[header-host]',
    standalone: false
})
export class HeaderDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}